const STATIC_TITLES = {
  "/": "Home",
  "/posts": "All Posts",
  "/photos": "Photos",
  "/about": "About",
  "/whiteboard": "Whiteboard",
  "/neo-tracker": "NEO Tracker",
  "/terminal": "Terminal",
  "/weather": "Weather",
  "/pixel-to-rem": "Pixels to Rem",
  "/quit-smoking": "Quit Smoking",
  "/budget": "Budget",
  "/json-schema": "Schema Generator",
  "/json-diff": "JSON Deep Diff",
  "/rpsls": "Rock Paper Scissors Lizard Spock",
  "/text-to-speech": "Text to Speech",
  "/warp": "Warp",
  "/crawl": "Crawl",
  "/lunar-lander": "Lunar Lander",
  "/driving-sim": "Parking Lot",
  "/gremlins": "Gremlins",
  "/list-view": "All Posts",
}

const CATEGORY_TITLES = {
  photos: "Photos",
  video: "Video",
  blog: "Blog",
}

/* Post slugs are `/<YYYY-MM-DD>/<post-slug>/`, so take the last segment only.
   Hyphenating the whole thing turns the date directory into "2026 04 29/...". */
const prettifySlug = slug => {
  const segment = slug.split("/").filter(Boolean).pop() || ""
  return segment.split("-").filter(Boolean).join(" ")
}

/**
 * Window title for a route. Posts keep their lowercase slug wording, which
 * matches how the titles are actually written in the frontmatter.
 */
export const windowTitleFor = location => {
  const pathname = (location?.pathname || "/").replace(/\/+$/, "") || "/"

  // The post list is one route filtered by query param, so the folder name
  // has to come from the param rather than the path.
  if (pathname === "/posts") {
    const category = new URLSearchParams(location?.search || "").get("category")
    return CATEGORY_TITLES[category] || STATIC_TITLES["/posts"]
  }

  if (STATIC_TITLES[pathname]) {
    return STATIC_TITLES[pathname]
  }

  if (pathname.startsWith("/blog/")) {
    return prettifySlug(pathname.slice("/blog/".length))
  }

  if (pathname.startsWith("/page/")) {
    return `Home (page ${pathname.slice("/page/".length)})`
  }

  return "phillipmorrow.com"
}
